import * as React from "react"
import { Helmet } from "react-helmet"
import tw from "twin.macro"

import background from "../images/background.png";
import logo from "../images/logo.png";

import "./index.css";

const IndexPage = () => (
  <main
    style={{ background: `#000 url(${background})`, backgroundPosition: 'center center' }}
    css={tw`w-screen text-white text-center py-20`}>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Storm Lantern Expeditions</title>
    </Helmet>

    <button css={tw`absolute right-10 top-7 tracking-widest hover:text-gray-400 text-sm`}>
      LOGIN
    </button>

    <div css={tw`px-8`}>
      <img
        css={tw`block m-auto mb-20 w-full max-w-lg`}
        src={logo}
        alt="Storm Lantern Expeditions"
      />

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        Our Credentials
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        We design and lead life-changing travel experiences anywhere in the world, without any limits.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        We are a 'stable' of guides and explorers, scholars and storytellers, friends and kindred spirits, drawn together over 30 years from every corner of the globe.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        Experts in our fields, we fit no mould, but share a love of place and passion for life.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        Together, we make Storm Lantern a truly unique company.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        We have little patience for cumbersome administration and desk-based 'travel design'. We are there on the ground ourselves. We listen to our guests, then create and lead experiences that honour their interests with joy and precision – the result is always something extraordinary.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        Our guests become friends, introduced only through word of mouth. We are loyal, discreet, and know them intimately.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        We have no public presence and no common brochure. Our privacy is both intentional and appreciated.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        Known for our extraordinary access, introductions, and connections, we help leave the world a better place.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        Honesty, kindness, and good manners are at the heart of our work – reflected in an exceptionally efficient office that quietly takes care of every detail from beginning to end of every journey.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        With a little irreverence and an unmistakable twinkle in our eye, we make the highly complex look beautifully simple.
      </p>

      <p css={tw`text-gray-400 tracking-wide`} style={{ maxWidth: `860px`, fontSize: '18px' }}>
        Please ask one of your friends to introduce us.
      </p>
    </div>
  </main>
);

export default IndexPage;
